const copy = {
  play: 'Play video',
  pause: 'Pause video',
  mute: 'Mute video',
  unmute: 'Unmute video',
  volume: 'Change volume',
  fullscreen: 'View video fullscreen',
  seek: 'Seek video',
  captions: 'Toggle captions',
  resolution: 'Change resolution'
}

export default copy



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/English.js